import app from 'new-ui/app';
import { ROUTE_NAME } from 'utils/constants/router';
import { UPLOAD_VIMEO_IDS } from './UploadFormConstants';

export const showSkip = () => {
  const $skip = document.querySelector('.upload-preloader .skip');
  if ($skip) {
    $skip.classList.add('visible');
  }
  const $prog = document.querySelector('.upload-preloader .upload-preloader-bar');
  if ($prog) {
    $prog.classList.add('visibility-hidden');
  }
};

export const getVimeoId = () => {
  if (app.isCurrentPage(ROUTE_NAME.SEARCH)) return UPLOAD_VIMEO_IDS[ROUTE_NAME.SEARCH];
  return UPLOAD_VIMEO_IDS[ROUTE_NAME.UPLOAD];
};
